export default "__VITE_ASSET__CGOGOcX___"